<template>
<div style="width:margin: 0 auto;">
    <HeadTop />
    <div class="book">
        <div class="boookLeft">
            <router-view @editWord='editWord' />
        </div>
        <div class="bookRight">
            <div class="uploadText" @click="upLoadModel">上传文章</div>
            <div class="writeText" @click="writeBook">写文章</div>
            <div class="rightDetail" @click="goMyBookList">
                <div class="allText">
                    <span class="allBook">全部文章</span>
                    <span class="num">{{statusMess.all}}</span>
                </div>
                <ul class="publishUl">
                    <li>
                        <div class="num">{{statusMess.passed}}</div>
                        <div class="text">已发布</div>
                    </li>
                    <li>
                        <div class="num">{{statusMess.checking}}</div>
                        <div class="text">审核中</div>
                    </li>
                    <li>
                        <div class="num">{{statusMess.noPass}}</div>
                        <div class="text">未通过</div>
                    </li>
                    <li>
                        <div class="num">{{statusMess.noCheck}}</div>
                        <div class="text">草稿箱</div>
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <a-modal
                title="上传文章"
                width="600px"
                footer=""
                :visible="upload"
                @ok="uploadModalOk"
                @cancel="uploadCancel"
                >
                <a-upload action="" @preview="handlePreview"
                    :before-upload="beforeUpload"
                    @change="handleChange">
                    <div class="uploadFun">
                        + 点击选择需要上传的文章，仅支持doc、pdf格式
                    </div>
                </a-upload>
                <ul class="fileList">
                    <li class="fileLi"  v-for="(item,index) in fileList" :key="index">
                        <img v-if="item.name.split('.')[1]=='doc'" class="fileImg" width="24px" hieght="24px" src="../../assets/image/34.png" alt="" />
                        <img v-if="item.name.split('.')[1]=='pdf'" class="fileImg" width="24px" hieght="24px" src="../../assets/image/33.png" alt="" />
                        <span class="fileName">{{item.name}}</span>
                        <img @click="fileDelete(index)"  class="fileDel" width="16px" hieght="16px" src="../../assets/teacherRoad/18.png" alt="" />
                    </li>
                </ul>
                    <div class="title" style="margin-top:20px;">
                        <div class="text">标题</div>
                        <div class="input"> <a-input v-model="title" placeholder="请输入标题" /></div>
                    </div>
                    <div class="author">
                        <div class="text">作者</div>
                        <div class="input"> <a-input v-model="author" placeholder="请输入作者" /></div>
                    </div>
                    <div class="type">
                        <div class="text">分类</div>
                        <div class="input">
                            <a-select default-value="高考点拨" style="width: 500px" @change="handleChangeSelect">
                                <a-select-option v-for="(item,index) in selectTop" :key="index" :value="item.id">
                                    {{item.name}}
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="classBot">
                        <a-button class="saveText"  @click="saveTextFun">保存草稿</a-button>
                        <a-button class="submitText" @click="submitTextFun">提交审核</a-button>
                    </div>
            </a-modal>
        </div>
    </div>
</div>
</template>

<script>
import HeadTop from '@/components/HeadTop'
import format from '@/utils/format.js'
import axios from 'axios'
export default {
  name: 'snailBookNew',
  data () {
    return {
      format,
      selectTop: [
        { name: '高考点拨', id: 2 }, { name: '教学反思', id: 3 }, { name: '教学设计', id: 4 },
        { name: '课程标准', id: 5 }, { name: '师生风采', id: 6 }, { name: '文本解读', id: 7 }, { name: '写作指导', id: 8 }
      ],
      selectCurrent: 0,
      pageSize: 5,
      pageNum: 1,
      total: 0,
      upload: false,
      fileList: [],
      newFileList: [],
      newFileName: '',
      firstFileName: '',
      statusMess: {}, // 状态信息
      artcileType: 2, // 分类
      author: '', // 作者
      title: '', // 标题
      editWordDetail: '',
      token: ''
    }
  },
  watch: {
    sessionStorage () {
      // console.log(sessionStorage.getItem('editWord'))
    }
  },
  mounted () {
    // this.$router.push({name: 'snailBookList',query:{status: ''}})
    this.token = localStorage.getItem('access_token')
    // this.$router.push({name: 'snailBookList'})
    this.getStatusCount()
  },
  methods: {
    editWord (item) {
      console.log('CHUANGUOLAIDE', item)
      this.editWordDetail = item
      this.upload = true
      this.fileList = item.fileList
      this.title = item.title
      this.author = item.authorName
    },
    // ebook/teacher/article/getMyArticleStatusCount
    getStatusCount () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/article/getMyArticleStatusCount',
        body: {
          userId: this.$getUserInfo().id
        }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.statusMess = res.resultData
        }
      })
    },

    upLoadModel () { // 打开上传弹窗
      this.fileList = []
      this.upload = true
    },
    writeBook () { // 写文章
      this.$router.push({ name: 'writeBook' })
    },
    uploadModalOk () { // 上传弹窗确认

    },
    uploadCancel () { // 上传弹窗关闭
      this.upload = false
    },
    handleChange ({ file, fileList }) { // 上传
      if (file.status !== 'uploading') {
        this.fileList = fileList
        this.fileList.forEach(item => {
          item.id = ''
          item.path = ''
        })
        this.fileList = this.fileList.slice(-1)
        this.fileList = this.fileList.map(file => {
          if (file.response) {
            file.url = file.response.url
          }
          return file
        })
      }
    },
    fileDelete (index) {
      this.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      // 根据file.name判断这个文件的类型是不是pdf或者doc或者docx，file.name可能包括多个点
      const extension = file.name.split('.').pop().toLowerCase()
      if (!['pdf', 'doc', 'docx'].includes(extension)) {
        this.$message.error('请上传正确的格式')
        return false
      }
      this.newFileName = file.name.split('.')[1]
      this.firstFileName = file.name.split('.')[0]
      // if (this.newFileName != 'doc' && this.newFileName != 'docx' && this.newFileName != 'pdf') {
      //   this.$message.error('请上传正确的格式')
      //   return false
      // }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('customDir', 'hytc_ebook_server/file')
      formData.append('access_token', this.token || '')
      // 上传图片方法
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          _this.fileList[0].path = res.data.url
        }
        _this.newFileList.push({
          id: '',
          path: res.data.url,
          name: _this.firstFileName
        })
      })
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChangeSelect (e) {
      console.log('handleChangeSelect',e)
      this.artcileType = e
      console.log('handleChangeSelect-1',this.artcileType)
    },
    saveTextFun () {
      console.log('saveTextFun',this.articleType)
      const param = {
        articleType: this.artcileType,
        title: this.title,
        authorName: this.author,
        fileList: this.newFileList,
        status: 0
      }
      if (this.author == '' || this.author == '' || this.fileList.length == 0) {
        this.$message.warning('请补全信息')
        return
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/article/saveArticle',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('保存草稿成功')
          this.upload = false
          this.getStatusCount()
        } else {
          this.$message.error(res.resultMessage)
        }
      })
    },
    submitTextFun () { // 提交
      console.log('submitTextFun',this.artcileType)
      const param = {
        articleType: this.artcileType,
        title: this.title,
        authorName: this.author,
        fileList: this.newFileList,
        status: 1
      }
      if (this.author == '' || this.author == '' || this.fileList.length == 0) {
        this.$message.warning('请补全信息')
        return
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/article/saveArticle',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('上传成功,等待审核')
          this.newFileList = []
          this.upload = false
          this.getStatusCount()
        } else {
          this.$message.error(res.resultMessage)
        }
      })
    },
    // lookDetail(status){
    //     this.$router.push({name: 'mySnailBookList',query:{status: status}})
    // },
    goMyBookList () {
      this.$router.push({ name: 'mySnailBookList' })
    }
  },
  components: {
    HeadTop
  }
}
</script>

<style lang="less" scoped>
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .book{
        //width: 1240px;
        margin: 0 auto;
        display: flex;
        .boookLeft{
            //width: 900px;
            flex: 1;
            min-height: 800px;
            background: #fff;
            border-radius: 4px;
            padding: 30px 0;
            .select_t{
                cursor: pointer;
                .spanText{
                    display: inline-block;
                    width: 120px;
                    height: 24px;
                    line-height:24px;
                    color: #000;
                    font-size: 14px;
                    text-align: center;
                    margin-right: 20px;
                }
            }
            .bookList{
                .bookDetail{
                    margin-top: 15px;
                    border-bottom: 1px solid #F0F0F0;
                    .title{
                        font-size: 16px;
                        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                        font-weight: 500;
                        color: #333;
                        line-height: 32px;
                        height: 32px;
                    }
                    .content{
                        font-size: 14px;
                        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                        font-weight: 400;
                        color: #333;
                        width: 700px;
                        height: 30px;
                        line-height: 30px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }
                    .userDetail{
                            height: 30px;
                            line-height: 30px;
                            margin-bottom: 10px;
                        .userPhoto{
                            width: 12px;
                            height: 12px;
                        }
                        .userName{
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #999999;
                            margin-left: 5px;
                        }
                        .classImg{
                            width: 12px;
                            height: 12px;
                            margin-left: 10px;
                        }
                        .classType{
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #999999;
                            margin-left: 5px;
                        }
                        .date{
                            float: right;
                            font-size: 12px;
                            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                            font-weight: 400;
                            color: #999999;
                        }
                    }
                }
            }
        }
        .bookRight{
            width: 310px;
            background: #fff;
            margin-left: 30px;
            height: 274px;
            border-radius: 4px;
            .uploadText{
                width: 160px;
                height: 32px;
                line-height: 32px;
                background: @primary-color;
                border-radius: 4px;
                border: 1px solid @primary-color;
                color: #fff;
                text-align: center;
                margin: 0 auto;
                margin-top: 25px;
                cursor: pointer;
            }
            .writeText{
                width: 160px;
                height: 32px;
                line-height: 32px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid @primary-color;
                text-align: center;
                margin: 0 auto;
                margin-top: 20px;
                cursor: pointer;
                color: @primary-color;
            }
            .rightDetail{
                cursor: pointer;
                .allText{
                    padding: 0px 32px;
                    margin-top: 40px;
                    font-size: 16px;
                    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                    font-weight: 400;
                    color: #333;
                    line-height: 24px;
                    .allBook{
                    }
                    .num{
                        margin-left: 10px;
                    }
                }
                .publishUl{
                    display: flex;
                    padding: 0px 20px;
                    margin-top: 30px;
                    li{
                        width: 25%;
                        text-align: center;
                        cursor: pointer;
                        .num{
                            font-size: 16px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            color: #A3AF90;
                            line-height: 20px;
                        }
                        .text{
                            font-size: 12px;
                            font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                            font-weight: 400;
                            color: #333;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }
    .uploadFun{
        width: 550px;
        margin: 0 auto;
        height: 48px;
        line-height: 48px;
        background: rgba(163, 175, 144, 0.1);
        border-radius: 4px;
        border: 2px dotted #A3AF90;
        text-align: center;
        color: #A3AF90;
        font-size: 14px;
    }
    .title,.author,.type{
        display: flex;
        height: 40px;
        margin-top: 10px;
        .text{
            width: 40px;
            font-size: 16px;
        }
        .input{
            width: 500px;
            margin-left: 10px;
            .ant-input{
                border: none;
                background: #f6f6f6;
                border-radius: 4px;
            }
            /deep/.ant-select-selection{
                border: none;
                background: #f6f6f6;
                border-radius: 4px;
            }
        }
    }
    .classBot{
        width: 100%;
        margin-top: 20px;
        text-align: right;
        .saveText{
            width: 80px;
            height: 24px;
            background: #FFFFFF;
            color: @primary-color;
            border-radius: 2px;
            border: 1px solid @primary-color;
            margin-right: 20px;
        }
        .submitText{
            width: 80px;
            height: 24px;
            background: @primary-color;
            color: #fff;
            border-radius: 2px;
            border: 1px solid @primary-color;
        }
    }
    .fileList{
        margin-top: 10px;
        .fileLi{
            height: 50px;
            line-height: 50px;
            padding: 0px 10px;
            background: rgba(255,154,74, .06);
            .fileImg{

            }
            .fileName{
                margin-left: 20px;
            }
            .fileDel{
                float: right;
                display: none;
                margin-right: 10px;
                margin-top: 18px;
            }
            &:hover{
                cursor: pointer;
                .fileDel{
                    display: block;

                }
            }
        }
    }
    /deep/.ant-upload-list-item{
        display: none;
    }
</style>
